"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPOCH_DATE = exports.CustomDate = void 0;
class CustomDate {
    static fromRaw(rawDate) {
        let time = rawDate.getTime();
        let date = this.fromTime(time);
        return date;
    }
    static fromHairia(hairia, timeInDay) {
        let time = exports.EPOCH_DATE.getTime() + (hairia - 1) * 86400000 + timeInDay;
        let date = this.fromTime(time);
        return date;
    }
    static current() {
        let time = new Date().getTime();
        let date = this.fromTime(time);
        return date;
    }
    convert(clazz) {
        let time = this.toTime();
        let date = clazz.fromTime(time);
        return date;
    }
    getTuple(shift) {
        let methodNames = ["getYear", "getMonth", "getDate", "getHairia", "getHours", "getMinutes", "getSeconds", "getMilliseconds"];
        let tuple = methodNames.map((methodName) => this[methodName](shift));
        return tuple;
    }
}
exports.CustomDate = CustomDate;
exports.EPOCH_DATE = new Date(2012, 0, 23, 0, 0, 0);
